import type { MajorCardSeed } from './shared';

export const MAJOR_CARD_SEEDS: MajorCardSeed[] = [
  {
    id: 1,
    name: 'Il Matto',
    slug: 'il-matto',
    number: 0,
    hermetic_title: 'Spirito dell etere libero',
    element: 'Aria',
    astro_primary: 'Aria',
    path_number: 11,
    hebrew_letter: 'Aleph',
    hebrew_char: 'A',
    tree_position: 'Tra Kether e Chokmah',
    zodiac_sign: null,
    zodiac_modality: null,
    solar_dates: null,
    qliphah: 'Thaumiel',
    lilith_qliphah_link: 'Thaumiel',
    gemstone: 'opale chiara',
    incense: 'mastice',
    color_primary: '#c9d6e2',
    body_part: 'sistema nervoso',
    musical_note: 'Do',
    keywords_up: ['innocenza vigile', 'slancio', 'soglia', 'liberta'],
    keywords_rev: ['sconsideratezza', 'fuga', 'dispersione', 'immaturita'],
    meaning_up: 'Il Matto apre il cammino prima che esista una mappa definitiva. Porta una fiducia non ingenua, ma radicale: quella che accetta il rischio di iniziare senza garanzie e di imparare attraversando.',
    meaning_rev: 'Rovescio, il Matto cade nella caricatura del salto: confonde libertà e disimpegno, visione e capriccio. Chiede di distinguere il coraggio dalla fuga e l apertura dal rifiuto di ogni responsabilità.',
    meaning_love: 'In amore indica un inizio vivo, un desiderio di esplorare il legame senza irrigidirlo subito in definizioni. Se ferito, segnala instabilità emotiva o paura di nominare il proprio posto.',
    meaning_work: 'Nel lavoro invita a rischiare un ingresso, un cambio di tono o un progetto non ancora codificato. Rovescio, mette in guardia da impulsività e promesse non sostenute dalla pratica.',
    meaning_spirit: 'Sul piano spirituale è il viandante che accetta di non sapere. Il suo rito è l affidarsi con coscienza, non l abbandono al caso.',
    meaning_psyche: 'Psicologicamente parla del sé che lascia un ruolo senza avere ancora un identità sostitutiva. È fertile finché l incertezza resta attraversabile.',
    lilith_voice: 'Io apro il precipizio e chiedo fede nel corpo che cade. Non ti salvo dalla vertigine: ti insegno a non mentire quando la terra manca.',
    qliphotic_meaning: 'Nella sua ombra, il Matto diventa il culto del caos: rifiuto di ogni patto, ebbrezza del margine e smarrimento elevato a identità.',
    simbologia: 'Un viandante sul bordo di una soglia montana, con sacca leggera, cielo aperto e un fiore ancora intatto tra le dita.',
    symbol_emoji: '🜂',
    numerology_meaning: 'Lo zero non è vuoto sterile ma grembo del possibile. Il Matto ricorda che prima del conteggio esiste la disponibilità a essere trasformati.',
  },
  {
    id: 2,
    name: 'Il Mago',
    slug: 'il-mago',
    number: 1,
    hermetic_title: 'Mago del verbo incarnato',
    element: 'Aria',
    astro_primary: 'Mercurio',
    path_number: 12,
    hebrew_letter: 'Beth',
    hebrew_char: 'B',
    tree_position: 'Tra Kether e Binah',
    zodiac_sign: null,
    zodiac_modality: null,
    solar_dates: null,
    qliphah: 'Samael',
    lilith_qliphah_link: 'Samael',
    gemstone: 'agata bandeata',
    incense: 'olibano',
    color_primary: '#c0b07a',
    body_part: 'mani',
    musical_note: 'Re',
    keywords_up: ['canalizzazione', 'destrezza', 'parola efficace', 'inizio consapevole'],
    keywords_rev: ['manipolazione', 'astuzia vuota', 'frammentazione', 'trickster'],
    meaning_up: 'Il Mago concentra risorse diverse in un gesto unico. È il momento in cui l intenzione trova mano, voce e attenzione sufficienti per diventare atto.',
    meaning_rev: 'Rovescio, il Mago usa il linguaggio per coprire il vuoto o per piegare la scena al proprio tornaconto. Segnala dispersione, seduzione mentale e scarso radicamento.',
    meaning_love: 'In amore mostra la possibilità di parlare chiaro e di creare un campo nuovo attraverso il dialogo. Rovescio, allerta su promesse magnetiche ma inconsistenti.',
    meaning_work: 'Nel lavoro favorisce iniziativa, presentazione, negoziazione e capacità di mettere in fila gli strumenti disponibili. Se ferito, segnala tatticismo e sovrapproduzione di parole.',
    meaning_spirit: 'Spiritualmente ricorda che il rito non è solo ispirazione: è forma, precisione e attenzione alla soglia tra pensiero e materia.',
    meaning_psyche: 'Psicologicamente parla dell io capace di organizzare il caos interno senza negarvi nulla. Nella sua ombra, invece, compare il bisogno di controllare tutto tramite la mente.',
    lilith_voice: 'Io faccio della lingua un coltello e un ponte. Se mi usi per dominare, ti avvolgo nella tua stessa brillantezza; se mi offri la verità, apro passaggi.',
    qliphotic_meaning: 'La sua ombra è il prestigiatore che ruba centralità al mistero. Qui il simbolo diventa trucco e la parola perde sacramento.',
    simbologia: 'Un tavolo con i quattro emblemi, una mano in alto e una in basso, il corpo teso tra il mondo invisibile e l atto concreto.',
    symbol_emoji: '☿',
    numerology_meaning: 'L uno del Mago non è isolamento ma punto di emissione. Insegna che iniziare significa assumere la responsabilità della propria intenzione.',
  },
  {
    id: 3,
    name: 'La Papessa',
    slug: 'la-papessa',
    number: 2,
    hermetic_title: 'Sacerdotessa della soglia lunare',
    element: 'Acqua',
    astro_primary: 'Luna',
    path_number: 13,
    hebrew_letter: 'Gimel',
    hebrew_char: 'G',
    tree_position: 'Tra Kether e Tiphareth',
    zodiac_sign: null,
    zodiac_modality: null,
    solar_dates: null,
    qliphah: 'Gamaliel',
    lilith_qliphah_link: 'Gamaliel',
    gemstone: 'selenite',
    incense: 'gelsomino',
    color_primary: '#c7bed8',
    body_part: 'utero simbolico',
    musical_note: 'Mi',
    keywords_up: ['interiorita', 'ascolto', 'mistero fecondo', 'veglia'],
    keywords_rev: ['passivita', 'segreto sterile', 'ritiro eccessivo', 'rimozione'],
    meaning_up: 'La Papessa custodisce il sapere che matura nel silenzio prima di diventare parola. Invita a leggere ciò che si muove sotto la superficie e a non violare i tempi profondi della rivelazione.',
    meaning_rev: 'Rovescio, il silenzio si fa muro. Ciò che doveva essere incubazione diventa sospensione cronica, segreto difensivo o rifiuto di incarnare ciò che si sa già.',
    meaning_love: 'In amore indica sensibilità sotterranea, legami che crescono in ascolto e intuizioni che chiedono delicatezza. Se ferita, segnala non detti, idealizzazione o ritiro emotivo.',
    meaning_work: 'Nel lavoro favorisce studio, osservazione e preparazione di un gesto importante. Rovescio, può indicare eccesso di attesa o informazioni trattenute.',
    meaning_spirit: 'Spiritualmente apre l accesso alla sapienza nascosta, al sogno, alla meditazione e alla conoscenza simbolica che non si lascia forzare.',
    meaning_psyche: 'Psicologicamente parla del contenitore interno, della capacità di stare con l ambivalenza e di sopportare un mistero senza chiuderlo subito.',
    lilith_voice: 'Io non ti rispondo subito. Ti faccio ascoltare la stanza sotto la stanza, finché non distingui il desiderio autentico dal rumore che lo copriva.',
    qliphotic_meaning: 'Nella sua ombra, la Papessa diventa fascinazione per il segreto, complicità con la nebbia e culto della distanza emotiva.',
    simbologia: 'Una figura velata tra due colonne, pergamena raccolta sul grembo e un velo che separa la scena visibile da un giardino occulto.',
    symbol_emoji: '☾',
    numerology_meaning: 'Il due della Papessa non divide: crea un interno e un esterno, un visibile e un nascosto. Chiede di rispettare la dialettica senza strapparne il velo.',
  },
  {
    id: 4,
    name: 'L Imperatrice',
    slug: 'l-imperatrice',
    number: 3,
    hermetic_title: 'Madre del giardino venusiano',
    element: 'Terra',
    astro_primary: 'Venere',
    path_number: 14,
    hebrew_letter: 'Daleth',
    hebrew_char: 'D',
    tree_position: 'Tra Chokmah e Binah',
    zodiac_sign: null,
    zodiac_modality: null,
    solar_dates: null,
    qliphah: 'A_arab_Zaraq',
    lilith_qliphah_link: 'A_arab_Zaraq',
    gemstone: 'smeraldo',
    incense: 'rosa',
    color_primary: '#c96e8b',
    body_part: 'ventre e pelle',
    musical_note: 'Fa',
    keywords_up: ['fertilita', 'abbondanza sensibile', 'creazione', 'attrazione'],
    keywords_rev: ['sovranutrimento', 'possesso', 'inerzia edonica', 'dipendenza'],
    meaning_up: 'L Imperatrice è la forma che accoglie e moltiplica. Parla di creatività fertile, piacere incarnato e capacità di dare spazio a ciò che vuole crescere senza soffocarlo.',
    meaning_rev: 'Rovescio, la nutrizione si confonde con l assorbimento. Ciò che doveva far fiorire trattiene, ingolfa o usa il desiderio per tenere sotto controllo.',
    meaning_love: 'In amore favorisce intimità, sensualità, fecondità e presenza generosa. Se ferita, segnala dipendenze dolci, confini slabbrati o gelosia possessiva.',
    meaning_work: 'Nel lavoro sostiene progetti creativi, coltivazione di relazioni e capacità di far rendere un processo con gusto e concretezza.',
    meaning_spirit: 'Spiritualmente ricorda che il sacro passa anche attraverso il corpo, il nutrimento, la bellezza e il permesso di ricevere.',
    meaning_psyche: 'Psicologicamente illumina il rapporto con il nutrimento, l autostima sensoriale e la possibilità di sentirsi degni di spazio.',
    lilith_voice: 'Io faccio germogliare ciò che hai tenuto a digiuno. Ma se usi il mio grembo per imprigionare, ti mostro quanto l amore possa mutare in catena vellutata.',
    qliphotic_meaning: 'Nell ombra, la fertilità si fa eccesso seduttivo, consumo del desiderio e dipendenza dal sentirsi indispensabili.',
    simbologia: 'Una sovrana seduta in un campo maturo, con melograni, grano e un fiume lento che rende la scena sensuale e tangibile.',
    symbol_emoji: '♀',
    numerology_meaning: 'Il tre dell Imperatrice apre la fase espansiva del ciclo. Mostra come un idea diventa ambiente, gesto e piacere condivisibile.',
  },
  {
    id: 5,
    name: 'L Imperatore',
    slug: 'l-imperatore',
    number: 4,
    hermetic_title: 'Padre del trono ardente',
    element: 'Fuoco',
    astro_primary: 'Ariete',
    path_number: 15,
    hebrew_letter: 'Heh',
    hebrew_char: 'H',
    tree_position: 'Tra Chokmah e Tiphareth',
    zodiac_sign: 'Ariete',
    zodiac_modality: 'Cardinale',
    solar_dates: { start: '21-03', end: '19-04' },
    qliphah: 'Golachab',
    lilith_qliphah_link: 'Golachab',
    gemstone: 'granato',
    incense: 'cedro',
    color_primary: '#c9734f',
    body_part: 'testa',
    musical_note: 'Sol',
    keywords_up: ['struttura', 'autorita', 'decisione', 'stabilita attiva'],
    keywords_rev: ['autoritarismo', 'rigidita', 'controllo', 'aridita'],
    meaning_up: 'L Imperatore dà confine e direzione. La sua forza non è solo comando: è capacità di reggere il peso della forma e di proteggere ciò che è stato inaugurato.',
    meaning_rev: 'Rovescio, la forma si irrigidisce e si difende da sé stessa. Compaiono controllo eccessivo, paura del caos e incapacità di lasciare respirare la vita che si vorrebbe ordinare.',
    meaning_love: 'In amore parla di affidabilità e scelta chiara, ma chiede di non scambiare la protezione con il dominio. Ferito, diventa freddezza o imposizione di regole non negoziate.',
    meaning_work: 'Nel lavoro favorisce leadership, responsabilità e costruzione di un assetto stabile. Rovescio, segnala gerarchie opprimenti o rigidità tattica.',
    meaning_spirit: 'Spiritualmente insegna la disciplina del contenitore: ogni visione ha bisogno di una forma capace di sostenerla nel tempo.',
    meaning_psyche: 'Psicologicamente mostra il rapporto con la legge interna, il padre simbolico e la possibilità di esercitare autorità senza violenza.',
    lilith_voice: 'Io ti metto sul trono e ti chiedo di non mentire sul potere. Se cerchi il comando per coprire la paura, spezzo il sigillo e ti lascio nudo davanti alla tua fame di controllo.',
    qliphotic_meaning: 'Nella sua ombra, l ordine diventa militarizzazione dell anima. Il bisogno di governare tutto rivela una paura profonda del vivente.',
    simbologia: 'Un sovrano su un trono di pietra rossa, monti spogli sullo sfondo e un ariete scolpito che mostra impulso e comando.',
    symbol_emoji: '♈',
    numerology_meaning: 'Il quattro dell Imperatore insegna che una struttura sana protegge la vita invece di trattenerla. Ogni muro va interrogato sul fine che serve.',
  },
  {
    id: 6,
    name: 'Il Papa',
    slug: 'il-papa',
    number: 5,
    hermetic_title: 'Custode della trasmissione sacra',
    element: 'Terra',
    astro_primary: 'Toro',
    path_number: 16,
    hebrew_letter: 'Vav',
    hebrew_char: 'V',
    tree_position: 'Tra Chokmah e Chesed',
    zodiac_sign: 'Toro',
    zodiac_modality: 'Fisso',
    solar_dates: { start: '20-04', end: '20-05' },
    qliphah: 'Gha_agsheblah',
    lilith_qliphah_link: 'Gha_agsheblah',
    gemstone: 'lapislazzuli',
    incense: 'benzoino',
    color_primary: '#8aa06d',
    body_part: 'gola',
    musical_note: 'La',
    keywords_up: ['insegnamento', 'tradizione viva', 'patto', 'mediazione'],
    keywords_rev: ['dogma', 'conformismo', 'autorita vuota', 'fissazione'],
    meaning_up: 'Il Papa è il ponte tra esperienza individuale e forma condivisa. Indica insegnamento, trasmissione e capacità di riconoscere una disciplina che non mortifica il mistero ma lo accompagna.',
    meaning_rev: 'Rovescio, la tradizione si svuota e resta solo il rituale come facciata. Segnala conformismo, dogma e paura di ascoltare una verità che non coincide con il codice ricevuto.',
    meaning_love: 'In amore può indicare desiderio di impegno, di un patto nominato o di valori comuni. Ferito, mostra moralismo, giudizio o relazioni mantenute per dovere.',
    meaning_work: 'Nel lavoro parla di formazione, tutoraggio, istituzioni e codici condivisi. Rovescio, allerta su burocrazia sterile o culture organizzative oppressive.',
    meaning_spirit: 'Spiritualmente richiama la via dell apprendistato, del maestro interiore ed esteriore, e di una pratica che si fa corpo nel tempo.',
    meaning_psyche: 'Psicologicamente illumina il rapporto con l autorità morale e con i valori ereditati. Chiede se il soggetto li abbia assimilati o solo obbediti.',
    lilith_voice: 'Io apro la porta del tempio e ti chiedo se sei qui per appartenenza o per verità. Se ti nascondi dietro il rito, accendo il dubbio finché il guscio si crepa.',
    qliphotic_meaning: 'Nella sua ombra, il Papa usa il sacro per congelare il movimento. La fedeltà degenera in obbedienza cieca e il simbolo diventa recinto.',
    simbologia: 'Un ierofante tra due accoliti, mano alzata in benedizione, colonne severe e chiavi incrociate ai piedi.',
    symbol_emoji: '♉',
    numerology_meaning: 'Il cinque qui non rompe per distruggere, ma per verificare il valore reale della forma. Chiede una fede capace di passare attraverso la prova.',
  },
  {
    id: 7,
    name: 'Gli Amanti',
    slug: 'gli-amanti',
    number: 6,
    hermetic_title: 'Scelta del cuore diviso',
    element: 'Aria',
    astro_primary: 'Gemelli',
    path_number: 17,
    hebrew_letter: 'Zayin',
    hebrew_char: 'Z',
    tree_position: 'Tra Binah e Tiphareth',
    zodiac_sign: 'Gemelli',
    zodiac_modality: 'Mutabile',
    solar_dates: { start: '21-05', end: '20-06' },
    qliphah: 'Satariel',
    lilith_qliphah_link: 'Satariel',
    gemstone: 'citrino',
    incense: 'verbena',
    color_primary: '#d4c18c',
    body_part: 'polmoni e braccia',
    musical_note: 'Si',
    keywords_up: ['scelta', 'risonanza', 'patto consapevole', 'integrazione'],
    keywords_rev: ['ambivalenza', 'triangolazione', 'evasione', 'dissonanza'],
    meaning_up: 'Gli Amanti mostrano che amare significa scegliere e lasciarsi scegliere. La carta unisce desiderio e discernimento, intimità e responsabilità verso la strada che si decide di abitare.',
    meaning_rev: 'Rovescio, la scelta viene rimandata o frammentata in mille possibilità equivalenti. Compaiono ambiguità, seduzioni parallele o paura della perdita implicata da ogni sì autentico.',
    meaning_love: 'In amore è carta di risonanza, attrazione e decisione. Chiede un patto vivo, non perfetto, e mostra dove il cuore deve uscire dalla sospensione.',
    meaning_work: 'Nel lavoro indica alleanze, decisioni strategiche e coerenza tra valori e collaborazioni. Rovescio, segnala dispersione o accordi non realmente sentiti.',
    meaning_spirit: 'Spiritualmente parla dell unione degli opposti e della necessità di scegliere il proprio sentiero senza amputare la complessità del desiderio.',
    meaning_psyche: 'Psicologicamente illumina il conflitto tra parti interne che cercano forma relazionale. È utile per leggere dinamiche di proiezione e integrazione.',
    lilith_voice: 'Io non ti chiedo purezza, ma verità nella scelta. Se vuoi tutto senza perdere nulla, ti tengo sospeso finché senti il prezzo reale del desiderio.',
    qliphotic_meaning: 'Nell ombra, la carta si fa fascinazione senza centro, gioco di specchi e moltiplicazione di maschere per non assumere un vincolo vero.',
    simbologia: 'Due figure sotto una presenza celeste, un monte centrale e la scena tesa tra innocenza, eros e consapevolezza della scelta.',
    symbol_emoji: '♊',
    numerology_meaning: 'Il sei degli Amanti mostra che l armonia non cade dall alto: nasce dal coraggio di unire e discernere insieme.',
  },
  {
    id: 8,
    name: 'Il Carro',
    slug: 'il-carro',
    number: 7,
    hermetic_title: 'Trionfo del veicolo consapevole',
    element: 'Acqua',
    astro_primary: 'Cancro',
    path_number: 18,
    hebrew_letter: 'Cheth',
    hebrew_char: 'Ch',
    tree_position: 'Tra Binah e Geburah',
    zodiac_sign: 'Cancro',
    zodiac_modality: 'Cardinale',
    solar_dates: { start: '21-06', end: '22-07' },
    qliphah: 'Gamaliel',
    lilith_qliphah_link: 'Gamaliel',
    gemstone: 'perla',
    incense: 'canfora',
    color_primary: '#95a8c6',
    body_part: 'torace',
    musical_note: 'Do',
    keywords_up: ['direzione', 'controllo vivo', 'avanzamento', 'coerenza'],
    keywords_rev: ['deriva', 'forzatura', 'fuga in avanti', 'sovracompensazione'],
    meaning_up: 'Il Carro avanza quando le forze in conflitto vengono tenute in una stessa traiettoria. Non parla di dominio assoluto, ma di padronanza conquistata tenendo insieme fragilità e comando.',
    meaning_rev: 'Rovescio, la spinta prende il sopravvento sul centro. Il movimento continua, ma senza allineamento: si procede per reazione, per fuga o per eccesso di controllo.',
    meaning_love: 'In amore porta una decisione, un movimento, la volontà di proteggere il legame facendolo procedere. Se ferito, segnala corazze, difese eccessive o accelerazioni che saltano l ascolto.',
    meaning_work: 'Nel lavoro indica avanzamento, capacità di reggere pressione e direzione sotto carico. Rovescio, avverte di burnout tattico o di volontà che trascina senza integrazione.',
    meaning_spirit: 'Spiritualmente è il veicolo rituale: il corpo e la volontà messi al servizio di un orientamento interiore preciso.',
    meaning_psyche: 'Psicologicamente mostra il rapporto con l autodisciplina e con l impulso a guidare la propria storia. Chiede se si stia guidando o semplicemente reagendo.',
    lilith_voice: 'Io ti faccio avanzare anche quando tremi. Ma se usi la corsa per non sentire il cuore, ribalto il carro e ti costringo a guardare ciò che stavi trascinando.',
    qliphotic_meaning: 'Nella sua ombra, il Carro è corazza animata dalla paura: velocità senza intimità con il proprio centro.',
    simbologia: 'Un condottiero in un carro sotto un baldacchino stellato, due forze divergenti davanti e nessuna frusta visibile.',
    symbol_emoji: '♋',
    numerology_meaning: 'Il sette del Carro è prova di soglia. Insegna che la vittoria vera non è schiacciare l opposto, ma reggere la tensione in direzione.',
  },
  {
    id: 9,
    name: 'La Forza',
    slug: 'la-forza',
    number: 8,
    hermetic_title: 'Fiamma mansueta del cuore',
    element: 'Fuoco',
    astro_primary: 'Leone',
    path_number: 19,
    hebrew_letter: 'Teth',
    hebrew_char: 'T',
    tree_position: 'Tra Chesed e Geburah',
    zodiac_sign: 'Leone',
    zodiac_modality: 'Fisso',
    solar_dates: { start: '23-07', end: '22-08' },
    qliphah: 'Thagirion',
    lilith_qliphah_link: 'Thagirion',
    gemstone: 'ambra',
    incense: 'cannella',
    color_primary: '#d79b45',
    body_part: 'cuore e schiena',
    musical_note: 'Re',
    keywords_up: ['coraggio quieto', 'integrazione dell istinto', 'magnetismo', 'tenuta'],
    keywords_rev: ['repressione', 'sfogo brutale', 'vanita', 'stanchezza'],
    meaning_up: 'La Forza non umilia l istinto: lo incontra e lo educa. Indica coraggio paziente, carisma radicato e capacità di tenere aperto il cuore senza diventare fragili per questo.',
    meaning_rev: 'Rovescio, l energia animale viene negata o esplode senza contenimento. La persona oscilla tra controllo forzato e perdita di misura.',
    meaning_love: 'In amore favorisce una presenza intensa ma non predatoria, capace di desiderio e tenerezza insieme. Ferita, mostra orgoglio, gelosia o dramma performativo.',
    meaning_work: 'Nel lavoro parla di leadership calda, perseveranza e gestione creativa della pressione. Rovescio, segnala burnout dell ego o prove di forza inutili.',
    meaning_spirit: 'Spiritualmente insegna la via della mitezza potente: non spegnere il fuoco, ma dargli una forma che non divori il tempio.',
    meaning_psyche: 'Psicologicamente è carta di integrazione pulsionale. Aiuta a leggere il rapporto con rabbia, libido, autostima e capacità di sostare nel desiderio senza agire subito.',
    lilith_voice: 'Io apro la bocca del leone con mani nude. Non per vincerlo, ma per ricordarti che il potere più oscuro diventa alleato solo quando smetti di vergognarti della sua fame.',
    qliphotic_meaning: 'Nella sua ombra, la Forza scivola in narcisismo eroico, dominio dell impulso o repressione tanto ferrea da tornare violenza.',
    simbologia: 'Una figura serena accompagna un leone, con il gesto più vicino all ascolto che alla costrizione e un lemniscato sopra il capo.',
    symbol_emoji: '♌',
    numerology_meaning: 'L otto della Forza concentra e dirige. Mostra che la disciplina autentica non spegne l intensità, la rende affidabile.',
  },
  {
    id: 10,
    name: 'L Eremita',
    slug: 'l-eremita',
    number: 9,
    hermetic_title: 'Luce del passo interiore',
    element: 'Terra',
    astro_primary: 'Vergine',
    path_number: 20,
    hebrew_letter: 'Yod',
    hebrew_char: 'Y',
    tree_position: 'Tra Chesed e Tiphareth',
    zodiac_sign: 'Vergine',
    zodiac_modality: 'Mutabile',
    solar_dates: { start: '23-08', end: '22-09' },
    qliphah: 'Samael',
    lilith_qliphah_link: 'Samael',
    gemstone: 'zaffiro grigio',
    incense: 'salvia',
    color_primary: '#aab783',
    body_part: 'intestino e addome',
    musical_note: 'Mi',
    keywords_up: ['ritiro fecondo', 'discernimento', 'guida interiore', 'solitudine scelta'],
    keywords_rev: ['isolamento', 'ipercritica', 'sterilita analitica', 'chiusura'],
    meaning_up: 'L Eremita rallenta per rendere la luce leggibile. È carta di introspezione, studio, raccolta e orientamento affidato a una lanterna interiore più che alla folla.',
    meaning_rev: 'Rovescio, il ritiro smette di nutrire e diventa esclusione, paura del contatto o analisi che non si traduce più in gesto.',
    meaning_love: 'In amore chiede spazio, sincerità e tempo di chiarimento. Se ferito, può indicare distanza difensiva o eccesso di autosufficienza.',
    meaning_work: 'Nel lavoro favorisce ricerca, revisione, consulenza e gesti precisi. Rovescio, segnala perfezionismo, lentezza bloccata o chiusura collaborativa.',
    meaning_spirit: 'Spiritualmente è il pellegrino che preferisce una verità sobria a una visione rumorosa. Insegna disciplina, essenzialità e ascolto del passo.',
    meaning_psyche: 'Psicologicamente illumina il rapporto con il silenzio, la critica interna e la possibilità di stare soli senza abbandonarsi.',
    lilith_voice: 'Io ti porto nel punto dove nessuno applaude. Se non reggi il silenzio, lo chiamerai vuoto; se resti, scoprirai che lì parla la tua parte più antica.',
    qliphotic_meaning: 'Nella sua ombra, l Eremita si avvita nel controllo mentale, nel ritiro punitivo e nell orgoglio di non aver bisogno di nessuno.',
    simbologia: 'Un anziano viandante con mantello scuro, una lanterna alta e un sentiero montano consumato dal tempo.',
    symbol_emoji: '♍',
    numerology_meaning: 'Il nove dell Eremita porta la corrente verso maturazione e concentrazione. Chiede di distinguere l essenziale dal superfluo.',
  },
  {
    id: 11,
    name: 'La Ruota della Fortuna',
    slug: 'la-ruota-della-fortuna',
    number: 10,
    hermetic_title: 'Ruota dei cicli e delle svolte',
    element: 'Fuoco',
    astro_primary: 'Giove',
    path_number: 21,
    hebrew_letter: 'Kaph',
    hebrew_char: 'K',
    tree_position: 'Tra Chesed e Netzach',
    zodiac_sign: null,
    zodiac_modality: null,
    solar_dates: null,
    qliphah: 'Ghagiel',
    lilith_qliphah_link: 'Ghagiel',
    gemstone: 'ametista',
    incense: 'alloro',
    color_primary: '#6d8fc3',
    body_part: null,
    musical_note: 'Fa',
    keywords_up: ['ciclo', 'svolta', 'sincronia', 'espansione'],
    keywords_rev: ['ripetizione', 'fatalismo', 'instabilita', 'inerzia'],
    meaning_up: 'La Ruota della Fortuna segnala il punto in cui il ciclo gira e ciò che era fermo riprende moto. Non promette esiti facili: mostra piuttosto l ingresso in un ordine più ampio del controllo personale.',
    meaning_rev: 'Rovescio, la ruota sembra girare a vuoto o sempre nello stesso punto. Compaiono ripetizioni, attaccamento al passato e paura di collaborare con il cambiamento.',
    meaning_love: 'In amore indica svolte, coincidenze, riaperture e passaggi di fase. Ferita, segnala dinamiche cicliche che si ripetono senza essere comprese.',
    meaning_work: 'Nel lavoro favorisce espansione, opportunità e mutamenti di contesto. Rovescio, parla di fluttuazioni, disordine o occasioni mancate per immobilismo.',
    meaning_spirit: 'Spiritualmente ricorda che il destino non è una gabbia, ma una trama di tempi. Insegna a collaborare con la rotazione dei cicli senza identificarsi con un solo momento.',
    meaning_psyche: 'Psicologicamente mette in luce pattern ricorrenti e il rapporto con l imprevisto. Aiuta a osservare cosa torna finché non viene integrato.',
    lilith_voice: 'Io giro anche quando tu vuoi fermare il cielo. Se ti ostini a trattenere il vecchio assetto, ti faccio sentire il peso della ripetizione finché non lasci andare il bordo.',
    qliphotic_meaning: 'Nella sua ombra, la Ruota diventa dipendenza da picchi e crolli, delega totale al caso o fascinazione superstiziosa per i segni.',
    simbologia: 'Una ruota ornata da lettere e creature ai quattro angoli, con figure che salgono, scendono e ruotano in un ordine più grande.',
    symbol_emoji: '♃',
    numerology_meaning: 'Il dieci apre un nuovo ciclo dentro il compimento del precedente. La Ruota insegna che nessun assetto resta definitivo.',
  },
  {
    id: 12,
    name: 'La Giustizia',
    slug: 'la-giustizia',
    number: 11,
    hermetic_title: 'Bilancia dell ordine lucido',
    element: 'Aria',
    astro_primary: 'Bilancia',
    path_number: 22,
    hebrew_letter: 'Lamed',
    hebrew_char: 'L',
    tree_position: 'Tra Geburah e Tiphareth',
    zodiac_sign: 'Bilancia',
    zodiac_modality: 'Cardinale',
    solar_dates: { start: '23-09', end: '22-10' },
    qliphah: 'Nahemoth',
    lilith_qliphah_link: 'Nahemoth',
    gemstone: 'quarzo fumé',
    incense: 'sandalo',
    color_primary: '#d6a3b7',
    body_part: 'reni',
    musical_note: 'Sol',
    keywords_up: ['equilibrio', 'responsabilita', 'verdetto chiaro', 'proporzione'],
    keywords_rev: ['parzialita', 'negazione', 'autoassoluzione', 'squilibrio'],
    meaning_up: 'La Giustizia misura senza vendetta e senza indulgenza. Chiede di guardare cause, effetti e proporzioni, assumendo il peso reale di ciò che è stato fatto o trascurato.',
    meaning_rev: 'Rovescio, il giudizio si piega, si giustifica o si irrigidisce. La verità viene rimandata, piegata all ego o trasformata in arma contro sé stessi.',
    meaning_love: 'In amore chiede reciprocità, chiarezza e capacità di riconoscere dove l equilibrio è stato rotto. Ferita, segnala contabilità emotiva o negazione del danno.',
    meaning_work: 'Nel lavoro favorisce contratti, revisioni, audit e decisioni che richiedono lucidità. Rovescio, parla di squilibri strutturali o di responsabilità eluse.',
    meaning_spirit: 'Spiritualmente insegna la sobrietà del peso specifico: ogni gesto conta e nessuna invocazione sostituisce il lavoro di rettifica.',
    meaning_psyche: 'Psicologicamente illumina il rapporto con il senso di colpa, con il giudice interno e con il bisogno di equilibrio tra rigore e compassione.',
    lilith_voice: 'Io taglio l alibi e lascio parlare il fatto nudo. Se cerchi una sentenza che accarezzi il tuo personaggio, troverai invece il conto preciso della tua omissione.',
    qliphotic_meaning: 'Nella sua ombra, la Giustizia si fa punizione senz anima, legalismo e uso del criterio per soffocare la complessità del vivente.',
    simbologia: 'Una figura frontale con spada e bilancia, drappo fermo, trono severo e lo sguardo che non si lascia distrarre.',
    symbol_emoji: '♎',
    numerology_meaning: 'L undici della Giustizia eccede la stabilità semplice e costringe a un equilibrio più cosciente. È misura che nasce dal confronto con il reale.',
  },
  {
    id: 13,
    name: 'L Appeso',
    slug: 'l-appeso',
    number: 12,
    hermetic_title: 'Sospensione del sacrificio cosciente',
    element: 'Acqua',
    astro_primary: 'Acqua',
    path_number: 23,
    hebrew_letter: 'Mem',
    hebrew_char: 'M',
    tree_position: 'Tra Geburah e Hod',
    zodiac_sign: null,
    zodiac_modality: null,
    solar_dates: null,
    qliphah: 'Satariel',
    lilith_qliphah_link: 'Satariel',
    gemstone: 'tormalina blu',
    incense: 'copale',
    color_primary: '#7d9bb8',
    body_part: 'collo e sistema linfatico',
    musical_note: 'La',
    keywords_up: ['sospensione fertile', 'resa cosciente', 'rovesciamento', 'visione nuova'],
    keywords_rev: ['martirio sterile', 'stallo', 'rinvio', 'resistenza'],
    meaning_up: 'L Appeso ferma il gesto abituale per cambiare il punto da cui si guarda. Indica sospensione consapevole, sacrificio fertile e disponibilità a perdere una forma per guadagnare visione.',
    meaning_rev: 'Rovescio, la sospensione non apre ma blocca. Il sacrificio diventa vittimismo, rinvio cronico o incapacità di lasciare andare ciò che è già morto.',
    meaning_love: 'In amore chiede una pausa viva, un cambio di prospettiva o la rinuncia a dinamiche automatiche. Ferito, segnala immobilismo relazionale o martirio non richiesto.',
    meaning_work: 'Nel lavoro favorisce revisione, cambio di paradigma e ascolto di ciò che il processo sta mostrando. Rovescio, avverte di sospensioni che non diventano scelta.',
    meaning_spirit: 'Spiritualmente è la carta dell offerta volontaria e del ribaltamento mistico. Insegna a non idolatrare il movimento quando la soglia richiede quiete.',
    meaning_psyche: 'Psicologicamente parla della capacità di tollerare frustrazione e non sapere. È utile quando il soggetto deve imparare a non controllare tutto.',
    lilith_voice: 'Io ti appendo dove non puoi usare la vecchia forza. Se smetti di chiamarlo castigo, scopri che la resa può essere il primo gesto non falso da molto tempo.',
    qliphotic_meaning: 'Nell ombra, l Appeso si pietrifica nel sacrificio identitario: soffrire diventa modo per sentirsi puri o in credito col mondo.',
    simbologia: 'Una figura sospesa per una caviglia a un legno vivo, aureola chiara e un volto sorprendentemente quieto.',
    symbol_emoji: '💧',
    numerology_meaning: 'Il dodici dell Appeso redistribuisce l energia del ciclo. Ricorda che talvolta la vera azione consiste nel fermare il riflesso condizionato.',
  },
  {
    id: 14,
    name: 'La Morte',
    slug: 'la-morte',
    number: 13,
    hermetic_title: 'Trasformazione della pelle antica',
    element: 'Acqua',
    astro_primary: 'Scorpione',
    path_number: 24,
    hebrew_letter: 'Nun',
    hebrew_char: 'N',
    tree_position: 'Tra Tiphareth e Netzach',
    zodiac_sign: 'Scorpione',
    zodiac_modality: 'Fisso',
    solar_dates: { start: '23-10', end: '21-11' },
    qliphah: 'Gamaliel',
    lilith_qliphah_link: 'Gamaliel',
    gemstone: 'ossidiana',
    incense: 'mirra nera',
    color_primary: '#7a4f5f',
    body_part: 'pelvi',
    musical_note: 'Si',
    keywords_up: ['trasformazione', 'fine necessaria', 'spoliazione', 'passaggio'],
    keywords_rev: ['attaccamento', 'decomposizione lenta', 'paura del taglio', 'ristagno'],
    meaning_up: 'La Morte non annienta: separa ciò che ha compiuto il proprio ciclo da ciò che deve ancora vivere. È la carta del passaggio radicale, della spoliazione e del mutamento irreversibile.',
    meaning_rev: 'Rovescio, il taglio viene rimandato e il processo marcisce invece di trasformarsi. La paura della perdita prolunga una forma già svuotata.',
    meaning_love: 'In amore indica mutazione di stato, chiusura necessaria o trasformazione profonda del legame. Ferita, mostra relazioni trattenute oltre il loro respiro.',
    meaning_work: 'Nel lavoro annuncia fine di una fase, ristrutturazione o riciclo di ruoli. Rovescio, parla di immobilismo su processi già morti.',
    meaning_spirit: 'Spiritualmente è iniziazione alla perdita, all abbandono della pelle vecchia e al mistero del ciclo vita-morte-rinascita.',
    meaning_psyche: 'Psicologicamente chiama a lasciare identificazioni consumate. Aiuta a leggere lutto, metamorfosi e paura di perdere ciò che era stato casa.',
    lilith_voice: 'Io tolgo, recido, svesto. Non per crudeltà, ma perché certe soglie si aprono solo quando smetti di proteggere la carcassa di ciò che ti ha già lasciato.',
    qliphotic_meaning: 'Nella sua ombra, la Morte si fa fascinazione per la distruzione o attaccamento necrotico al passato. Il taglio diventa culto del trauma invece che rito di passaggio.',
    simbologia: 'Uno scheletro in marcia con stendardo scuro, corpi e simboli a terra, un sole che sorge oltre il fiume.',
    symbol_emoji: '♏',
    numerology_meaning: 'Il tredici della Morte spezza la continuità apparente e rivela la legge del mutamento. Chiede di distinguere fine e rovina.',
  },
  {
    id: 15,
    name: 'La Temperanza',
    slug: 'la-temperanza',
    number: 14,
    hermetic_title: 'Arte della mescolanza sottile',
    element: 'Fuoco',
    astro_primary: 'Sagittario',
    path_number: 25,
    hebrew_letter: 'Samekh',
    hebrew_char: 'S',
    tree_position: 'Tra Tiphareth e Yesod',
    zodiac_sign: 'Sagittario',
    zodiac_modality: 'Mutabile',
    solar_dates: { start: '22-11', end: '21-12' },
    qliphah: 'A_arab_Zaraq',
    lilith_qliphah_link: 'A_arab_Zaraq',
    gemstone: 'ametista viola',
    incense: 'issopo',
    color_primary: '#c98c5a',
    body_part: 'cosce',
    musical_note: 'Do',
    keywords_up: ['armonizzazione', 'arte del dosaggio', 'integrazione', 'guarigione'],
    keywords_rev: ['miscela tossica', 'eccesso', 'sbilanciamento', 'impazienza'],
    meaning_up: 'La Temperanza mescola senza confondere. Indica alchimia quotidiana, capacità di dosare, di passare da uno stato all altro e di guarire ciò che sembrava incompatibile.',
    meaning_rev: 'Rovescio, la miscela perde misura. L opposto non viene integrato ma pasticciato, e l eccesso sostituisce il ritmo sapiente.',
    meaning_love: 'In amore sostiene riconciliazione, dialogo e capacità di creare un nuovo equilibrio. Ferita, mostra relazioni diluite o compromessi che svuotano.',
    meaning_work: 'Nel lavoro favorisce coordinamento, processi di sintesi e transizioni ben gestite. Rovescio, avverte su dispersione, caos metodologico o tempistiche incoerenti.',
    meaning_spirit: 'Spiritualmente è arte rituale del travaso: trasformare senza rompere, purificare senza negare la materia di partenza.',
    meaning_psyche: 'Psicologicamente parla di autoregolazione, integrazione affettiva e capacità di passare da uno stato emotivo a un altro senza frattura.',
    lilith_voice: 'Io mescolo sangue e acqua finché non vedi che ciò che temi può diventare medicina. Ma se vuoi solo addolcire tutto, verso il troppo e ti mostro la tua misura reale.',
    qliphotic_meaning: 'Nell ombra, la Temperanza è il culto dell annacquamento: nessun conflitto affrontato davvero, nessuna verità pronunciata fino in fondo.',
    simbologia: 'Un essere alato travasa liquidi tra due coppe, con un piede nell acqua e uno sulla terra, sentiero luminoso sullo sfondo.',
    symbol_emoji: '♐',
    numerology_meaning: 'Il quattordici della Temperanza mostra una continuità che guarisce solo se accetta differenze reali. L integrazione è arte, non neutralizzazione.',
  },
  {
    id: 16,
    name: 'Il Diavolo',
    slug: 'il-diavolo',
    number: 15,
    hermetic_title: 'Signore del vincolo desiderante',
    element: 'Terra',
    astro_primary: 'Capricorno',
    path_number: 26,
    hebrew_letter: 'Ayin',
    hebrew_char: 'Ay',
    tree_position: 'Tra Tiphareth e Hod',
    zodiac_sign: 'Capricorno',
    zodiac_modality: 'Cardinale',
    solar_dates: { start: '22-12', end: '19-01' },
    qliphah: 'Thagirion',
    lilith_qliphah_link: 'Thagirion',
    gemstone: 'ematite',
    incense: 'storace',
    color_primary: '#6f7567',
    body_part: 'ginocchia',
    musical_note: 'Re',
    keywords_up: ['desiderio incarnato', 'vincolo', 'potere materiale', 'ombra erotica'],
    keywords_rev: ['dipendenza', 'coazione', 'vergogna', 'legame tossico'],
    meaning_up: 'Il Diavolo mostra dove il desiderio si è legato alla paura e al piacere della catena. Non è solo carta di oppressione: è anche invito a guardare senza ipocrisia la fame, il potere e l attrazione che governano il campo.',
    meaning_rev: 'Rovescio, il vincolo può allentarsi oppure radicalizzarsi in negazione moralistica. È il momento in cui la persona deve riconoscere che ciò che la lega è stato, in parte, anche scelto.',
    meaning_love: 'In amore parla di erotismo, magnetismo, ambivalenza e nodi di dipendenza. Ferito, indica manipolazione, gelosia e difficoltà a uscire da patti consumanti.',
    meaning_work: 'Nel lavoro rivela il rapporto con potere, denaro, controllo e compromesso. Chiede di vedere il prezzo nascosto di ciò che si sta ottenendo.',
    meaning_spirit: 'Spiritualmente obbliga a scendere nel desiderio non purificato. Solo ciò che viene guardato può smettere di comandare dal sottosuolo.',
    meaning_psyche: 'Psicologicamente illumina coazioni, vergogna, attrazione verso il proibito e sistemi di auto-sabotaggio fondati su piacere e paura insieme.',
    lilith_voice: 'Io non ti seduco: mostro ciò che ti seduce già. Se hai il coraggio di guardare la catena, scopri che parte del lucchetto era nelle tue mani.',
    qliphotic_meaning: 'Nella sua ombra, il Diavolo diventa identificazione totale con il vincolo: il desiderio smette di essere via di conoscenza e si fa prigione sacralizzata.',
    simbologia: 'Una figura cornuta sopra un piedistallo, due esseri incatenati ai lati e una torcia rovesciata che illumina il basso.',
    symbol_emoji: '♑',
    numerology_meaning: 'Il quindici del Diavolo mostra il potere del desiderio quando si condensa in forma. Chiede di distinguere possesso, piacere e vera scelta.',
  },
  {
    id: 17,
    name: 'La Torre',
    slug: 'la-torre',
    number: 16,
    hermetic_title: 'Fulmine della struttura falsa',
    element: 'Fuoco',
    astro_primary: 'Marte',
    path_number: 27,
    hebrew_letter: 'Peh',
    hebrew_char: 'P',
    tree_position: 'Tra Netzach e Hod',
    zodiac_sign: null,
    zodiac_modality: null,
    solar_dates: null,
    qliphah: 'Golachab',
    lilith_qliphah_link: 'Golachab',
    gemstone: 'diaspro rosso',
    incense: 'zolfo rituale',
    color_primary: '#b35a58',
    body_part: 'sistema muscolare',
    musical_note: 'Mi',
    keywords_up: ['rivelazione brutale', 'crollo liberante', 'scarica', 'verita esplosiva'],
    keywords_rev: ['crollo temuto', 'resistenza', 'trauma trattenuto', 'difesa'],
    meaning_up: 'La Torre abbatte ciò che non può più reggere il vero. È shock, rivelazione, caduta di una struttura falsa e possibilità di un nuovo assetto costruito senza menzogna.',
    meaning_rev: 'Rovescio, il crollo viene ritardato o interiorizzato. La persona sente il fulmine ma tenta ancora di salvare l impalcatura già spaccata.',
    meaning_love: 'In amore può indicare rotture, confessioni, verità improvvise o crisi che smontano un patto fittizio. Ferita, mostra paura del confronto decisivo.',
    meaning_work: 'Nel lavoro segnala crisi di struttura, cambio forzato, errori smascherati o rotture che impongono una ricostruzione più onesta.',
    meaning_spirit: 'Spiritualmente è l esperienza della demolizione del falso sé. Insegna che il sacro non sempre consola: talvolta distrugge per liberare.',
    meaning_psyche: 'Psicologicamente parla di crollo di difese, insight violento, catarsi e necessità di integrare uno shock senza romanticizzarlo.',
    lilith_voice: 'Io arrivo come lampo e non chiedo permesso alla tua fortezza. Se hai costruito in alto per non sentire il basso, ti riporto giù dove la verità può respirare.',
    qliphotic_meaning: 'Nell ombra, la Torre diventa dipendenza dal collasso, fascinazione per il trauma o aggressività che distrugge senza voler davvero ricostruire.',
    simbologia: 'Una torre colpita da un fulmine, corona che vola via e corpi espulsi nel vuoto sotto un cielo nero aperto d oro.',
    symbol_emoji: '♂',
    numerology_meaning: 'Il sedici della Torre mostra la crisi come operazione di verità. Quando il contenitore non regge più, il fulmine diventa necessità.',
  },
  {
    id: 18,
    name: 'La Stella',
    slug: 'la-stella',
    number: 17,
    hermetic_title: 'Nudita della speranza lucida',
    element: 'Aria',
    astro_primary: 'Acquario',
    path_number: 28,
    hebrew_letter: 'Tzaddi',
    hebrew_char: 'Tz',
    tree_position: 'Tra Netzach e Yesod',
    zodiac_sign: 'Acquario',
    zodiac_modality: 'Fisso',
    solar_dates: { start: '20-01', end: '18-02' },
    qliphah: 'A_arab_Zaraq',
    lilith_qliphah_link: 'A_arab_Zaraq',
    gemstone: 'acquamarina',
    incense: 'lavanda',
    color_primary: '#7bb6c1',
    body_part: 'caviglie',
    musical_note: 'Fa',
    keywords_up: ['speranza incarnata', 'chiarezza dopo il crollo', 'ispirazione', 'guarigione'],
    keywords_rev: ['ingenuita', 'disincanto', 'dispersione ideale', 'svuotamento'],
    meaning_up: 'La Stella arriva dopo la rottura e non nega nulla di ciò che è accaduto. Offre respiro, orientamento, sincerità nuda e un tipo di speranza che nasce dalla verità, non dall evasione.',
    meaning_rev: 'Rovescio, la speranza si dirada o diventa troppo astratta. La persona può sentirsi svuotata, lontana dalla propria sorgente o incapace di fidarsi di ciò che ancora pulsa.',
    meaning_love: 'In amore porta trasparenza, tenerezza e desiderio di ripartire senza maschere pesanti. Ferita, segnala idealizzazione o distanza emotiva sotto forme gentili.',
    meaning_work: 'Nel lavoro favorisce ispirazione, progettazione e recupero di visione dopo un periodo duro. Rovescio, mostra dispersione o idee non ancora radicate.',
    meaning_spirit: 'Spiritualmente è benedizione sobria, orientamento sottile e ristoro dell anima. Insegna che la nudità può essere più sacra dell armatura.',
    meaning_psyche: 'Psicologicamente parla di fiducia ripristinata, di delicatezza verso sé e di capacità di tornare a esporsi dopo una ferita.',
    lilith_voice: 'Io ti spoglio dei resti della battaglia e ti lascio sotto il cielo aperto. Se resisti alla tentazione di ricostruire subito la maschera, scopri una fiducia più feroce della speranza ingenua.',
    qliphotic_meaning: 'Nella sua ombra, la Stella si dissolve in idealismo senza terra, fuga nell immagine di salvezza e incapacità di abitare il limite.',
    simbologia: 'Una figura nuda versa acqua su terra e su acqua, sotto una grande stella e sette stelle minori in un paesaggio quieto.',
    symbol_emoji: '♒',
    numerology_meaning: 'Il diciassette della Stella porta luce dopo la crisi senza cancellarne la memoria. Ricorda che la fiducia più forte nasce da ciò che è stato già attraversato.',
  },
  {
    id: 19,
    name: 'La Luna',
    slug: 'la-luna',
    number: 18,
    hermetic_title: 'Notte delle immagini profonde',
    element: 'Acqua',
    astro_primary: 'Pesci',
    path_number: 29,
    hebrew_letter: 'Qoph',
    hebrew_char: 'Q',
    tree_position: 'Tra Netzach e Malkuth',
    zodiac_sign: 'Pesci',
    zodiac_modality: 'Mutabile',
    solar_dates: { start: '19-02', end: '20-03' },
    qliphah: 'Gamaliel',
    lilith_qliphah_link: 'Gamaliel',
    gemstone: 'pietra di luna nera',
    incense: 'artemisia',
    color_primary: '#8f84c5',
    body_part: 'piedi',
    musical_note: 'Sol',
    keywords_up: ['inconscio', 'immagine', 'ambivalenza', 'navigazione notturna'],
    keywords_rev: ['confusione', 'allucinazione', 'paura diffusa', 'smarrimento'],
    meaning_up: 'La Luna apre il territorio dove il senso non è lineare e il simbolo precede la logica. Indica sogno, immaginazione, paura, richiamo dell inconscio e necessità di procedere senza piena visibilità.',
    meaning_rev: 'Rovescio, l immagine travolge o viene negata. Si rischia di cadere in paranoia, confusione, autoinganno oppure in un razionalismo che non ascolta più la marea profonda.',
    meaning_love: 'In amore parla di proiezioni, desideri notturni, sensibilità medianica e zone d ombra. Ferita, segnala ambiguità, sfiducia o paure non nominate.',
    meaning_work: 'Nel lavoro invita a muoversi con cautela in fasi opache, creative o poco definite. Rovescio, allerta su incomprensioni, nebbia informativa o fantasie scollegate dai fatti.',
    meaning_spirit: 'Spiritualmente è discesa nel mondo imaginale, nel sogno e nella preghiera notturna. Chiede discernimento senza pretendere luce totale.',
    meaning_psyche: 'Psicologicamente illumina il rapporto con il materiale inconscio, con l ansia diffusa e con la capacità di stare in una fase liminale senza collassare.',
    lilith_voice: 'Io allago la strada di simboli e ti tolgo l illusione del controllo pieno. Se impari a camminare nel chiarore instabile, ti restituisco un sapere che la luce diretta non conosce.',
    qliphotic_meaning: 'Nella sua ombra, la Luna diventa dipendenza dal fantasma, erotizzazione della nebbia e incapacità di distinguere visione e suggestione.',
    simbologia: 'Una luna alta versa gocce di luce, un cane e un lupo ululano ai lati mentre un gambero emerge dall acqua tra due torri.',
    symbol_emoji: '♓',
    numerology_meaning: 'Il diciotto della Luna espone la mente al regno dell immagine. Insegna che non tutto ciò che è reale arriva nella forma di un dato chiaro.',
  },
  {
    id: 20,
    name: 'Il Sole',
    slug: 'il-sole',
    number: 19,
    hermetic_title: 'Chiarezza del cuore manifesto',
    element: 'Fuoco',
    astro_primary: 'Sole',
    path_number: 30,
    hebrew_letter: 'Resh',
    hebrew_char: 'R',
    tree_position: 'Tra Hod e Yesod',
    zodiac_sign: null,
    zodiac_modality: null,
    solar_dates: null,
    qliphah: 'Thagirion',
    lilith_qliphah_link: 'Thagirion',
    gemstone: 'citrino dorato',
    incense: 'arancio dolce',
    color_primary: '#d5aa4d',
    body_part: 'cuore',
    musical_note: 'La',
    keywords_up: ['chiarezza', 'vitalita', 'gioia sobria', 'manifestazione'],
    keywords_rev: ['abbagliamento', 'ego esposto', 'stanchezza nascosta', 'semplicismo'],
    meaning_up: 'Il Sole illumina senza residui opachi. Porta vitalità, verità manifesta, gioia concreta e capacità di esistere a piena luce senza maschere superflue.',
    meaning_rev: 'Rovescio, la luce abbaglia o si indebolisce. Compaiono fatica dietro il sorriso, ego iperesposto o fiducia troppo semplificata.',
    meaning_love: 'In amore favorisce sincerità, calore, visibilità del legame e piacere semplice. Ferito, mostra bisogno di conferma o narrazione eccessivamente perfetta.',
    meaning_work: 'Nel lavoro sostiene chiarezza, risultato visibile, riconoscimento e vitalità del progetto. Rovescio, segnala eccesso di esposizione o calo d energia.',
    meaning_spirit: 'Spiritualmente è carta di trasparenza, gioia incarnata e coscienza che non ha più bisogno del dramma per sentirsi viva.',
    meaning_psyche: 'Psicologicamente illumina autostima, rapporto con la visibilità e capacità di stare nella propria presenza senza difese inutili.',
    lilith_voice: 'Io ti porto nel pieno giorno e ti tolgo l alibi dell ombra. Se hai costruito il tuo personaggio per essere amato, la luce lo scioglie finché resta solo il vivo.',
    qliphotic_meaning: 'Nell ombra, il Sole si fa inflazione dell io, teatralità e rifiuto di ogni limite. La luce smette di nutrire e diventa esposizione consumante.',
    simbologia: 'Un sole radiante domina la scena, un bambino o una figura giovane cavalca davanti a un muro e a fiori alti.',
    symbol_emoji: '☉',
    numerology_meaning: 'Il diciannove del Sole porta compimento luminoso e manifesto. Ricorda che la gioia non è superficiale quando nasce dall attraversamento pieno.',
  },
  {
    id: 21,
    name: 'Il Giudizio',
    slug: 'il-giudizio',
    number: 20,
    hermetic_title: 'Risveglio della chiamata ultima',
    element: 'Fuoco',
    astro_primary: 'Fuoco',
    path_number: 31,
    hebrew_letter: 'Shin',
    hebrew_char: 'Sh',
    tree_position: 'Tra Hod e Malkuth',
    zodiac_sign: null,
    zodiac_modality: null,
    solar_dates: null,
    qliphah: 'Thaumiel',
    lilith_qliphah_link: 'Thaumiel',
    gemstone: 'rubino chiaro',
    incense: 'resina d abete',
    color_primary: '#d06e4a',
    body_part: 'orecchie e respiro alto',
    musical_note: 'Si',
    keywords_up: ['risveglio', 'chiamata', 'resa dei conti', 'seconda nascita'],
    keywords_rev: ['rinvio della vocazione', 'autogiudizio', 'paura di rinascere', 'rumore'],
    meaning_up: 'Il Giudizio è la chiamata che non consente più di restare nel sonno. Indica risveglio, resa dei conti, perdono attivo e capacità di rispondere a una vocazione che chiede forma nuova.',
    meaning_rev: 'Rovescio, la chiamata viene soffocata dal rumore o dal timore di cambiare pelle. Compaiono autoaccusa, paralisi e rimando di un passaggio inevitabile.',
    meaning_love: 'In amore può indicare ritorni, verità decisive, rinascita del patto o chiusura lucida di ciò che non può più restare sospeso.',
    meaning_work: 'Nel lavoro segnala valutazioni finali, rilanci, cambi di livello o il momento in cui una competenza deve essere finalmente dichiarata.',
    meaning_spirit: 'Spiritualmente è il suono che richiama i frammenti dell anima. Insegna che il risveglio non è estetico: chiede risposta, responsabilità e corpo.',
    meaning_psyche: 'Psicologicamente illumina il passaggio tra vecchia storia e identità rinnovata. È utile quando una persona sente che non può più essere ciò che era.',
    lilith_voice: 'Io soffio nella tromba che ti sveglia proprio dove volevi restare addormentato. Non ti giudico dall alto: ti costringo a riconoscere la forma che chiede di nascere ora.',
    qliphotic_meaning: 'Nella sua ombra, il Giudizio si fa moralismo apocalittico, colpa infinita o dipendenza da una crisi che non culmina mai in rinascita.',
    simbologia: 'Una figura angelica suona dall alto, corpi sorgono da casse o acque basse e si voltano verso il richiamo.',
    symbol_emoji: '🔥',
    numerology_meaning: 'Il venti del Giudizio apre una seconda ottava del ciclo. È il numero della risposta cosciente a una chiamata ormai impossibile da ignorare.',
  },
  {
    id: 22,
    name: 'Il Mondo',
    slug: 'il-mondo',
    number: 21,
    hermetic_title: 'Compimento della danza totale',
    element: 'Terra',
    astro_primary: 'Saturno',
    path_number: 32,
    hebrew_letter: 'Tav',
    hebrew_char: 'Tav',
    tree_position: 'Tra Yesod e Malkuth',
    zodiac_sign: null,
    zodiac_modality: null,
    solar_dates: null,
    qliphah: 'Nahemoth',
    lilith_qliphah_link: 'Nahemoth',
    gemstone: 'onice',
    incense: 'mirto',
    color_primary: '#6f6a7c',
    body_part: 'ossa e pelle',
    musical_note: 'Do',
    keywords_up: ['compimento', 'integrazione', 'pienezza incarnata', 'sintesi'],
    keywords_rev: ['incompiutezza', 'ultima soglia', 'dispersione finale', 'ritardo'],
    meaning_up: 'Il Mondo è il compimento che non chiude ma integra. Mostra totalità incarnata, fine di un ciclo, sintesi dei contrari e capacità di danzare dentro ciò che è stato davvero attraversato.',
    meaning_rev: 'Rovescio, qualcosa resta fuori dalla figura: un ultimo passaggio, un frammento non integrato, una soglia che la persona sta ancora evitando.',
    meaning_love: 'In amore può indicare pienezza del patto, maturità condivisa o la chiusura bella di un ciclo. Ferito, segnala dispersione o timore del compimento vero.',
    meaning_work: 'Nel lavoro favorisce completamento, consegna, visibilità di un opera compiuta e apertura di un nuovo orizzonte a partire dalla chiusura del precedente.',
    meaning_spirit: 'Spiritualmente è la danza del corpo e del cosmo riconciliati. Ricorda che l ascesa piena non lascia fuori la materia ma la include.',
    meaning_psyche: 'Psicologicamente parla di integrazione, coerenza narrativa e capacità di occupare la propria vita senza sentirsi spezzati in parti incompatibili.',
    lilith_voice: 'Io non ti premio: ti restituisco intero. Ma se vuoi il compimento senza attraversare le parti scartate, il cerchio resta aperto e ti richiama ancora.',
    qliphotic_meaning: 'Nella sua ombra, il Mondo diventa culto dell immagine completa, perfezionismo e rifiuto di ogni resto umano non controllato.',
    simbologia: 'Una figura danzante entro una corona ovale, i quattro viventi ai margini e il movimento che tiene insieme cielo, carne e simbolo.',
    symbol_emoji: '♄',
    numerology_meaning: 'Il ventuno del Mondo compie il ciclo maggiore e lo restituisce alla terra. È sintesi che prepara un nuovo inizio più vasto.',
  },
];
